import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import {
	getToken,
	canTurnTo
} from '@/libs/util'
import iView from 'view-design'

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
}

const Home = () => import('@/views/home/Home.vue')
const Login = () => import('@/views/login/Login.vue')
const homePage = () => import('@/components/shouye/Shouye.vue')
const Task = () => import('@/components/task/Task.vue')
const Statistics = () => import('@/components/statistics/Statistics.vue')
const Client = () => import('@/components/client/Client.vue')
const Tool = () => import('@/components/tool/Tool.vue')
const EditClue = () => import('@/components/client/EditClue.vue')
const RoleAuthority = () => import('@/components/roleAuthority/RoleAuthority.vue')
const UpGrade = () => import('@/components/upgrade/UpGrade.vue')
const BuyQuantity = () => import('@/components/upgrade/BuyQuantity.vue')
const BuyTime = () => import('@/components/upgrade/BuyTime.vue')
const Order = () => import('@/components/upgrade/Order.vue')
const informcenter = () => import('@/components/informCenter/InformCenter.vue')
const MyCenter = () => import('@/components/myCenter/MyCenter.vue')
const TalentPool = () => import('@/components/talentPool/TalentPool.vue')
const NewTalents = () => import('@/components/talentPool/NewTalents.vue')
const RunSet = () => import('@/components/runSet/RunSet.vue')
const AddProduct = () => import('@/components/runSet/AddProduct.vue')
const MareLiberum = () => import('@/components/mareliberum/MareLiberum.vue')
const Finance = () => import('@/components/finance/Finance.vue')
const SectorSetup = () => import('@/components/sectorSetup/SectorSetup.vue')
const OrganizationMember = () => import('@/components/organizationMember/OrganizationMember.vue') //组织成员
const HelpCenter = () => import('@/components/helpCenter/HelpCenter.vue') //帮助中心
const adminSet = () => import('@/components/admin/adminSet.vue') //后台设置
const information = () => import('@/components/admin/information.vue') //信息查询列表
const PayInfo = () => import('@/components/finance/PayInfo.vue')
const ChooseShop = () => import('@/components/admin/ChooseShop.vue')
const ShopClient = () => import('@/components/client/ShopClient.vue')



//客户管理路由
const MyClient = () => import('@/components/client/Myclient.vue') //我的客户
const RedistributionClient = () => import('@/components/client/RedistributionClient.vue') //再分配客户
const Introduce = () => import('@/components/client/Introduce.vue') //转介绍客户
const TeamClient = () => import('@/components/client/TeamClient.vue') //团队客户

const publicPool = () => import('@/components/client/PublicPool.vue') //公共池
const performance_ranking = () => import('@/components/statistics/RankData.vue') //业绩排行榜
const newEditClue = () => import('@/components/client/NewEditClue.vue') //客户详情页
const editClue = () => import('@/components/client/EditClue.vue') //客户详情页
const ImportantClient = () => import('@/components/client/ImportantClient.vue') //我的重要客户

const HistoryCreateMoney = () => import('@/components/statistics/HistoryCreateMoney.vue') //历史数据创收
const Memo = () => import('@/components/client/Memo.vue') //提醒
const repeat_client = () => import('@/components/client/RepeatClient.vue') //重复客户
const employee_client = () => import('@/components/client/EmployeeClient.vue') //离职人员客户分配

//日志报表
const task = () => import('@/components/task/JobRecord .vue')
//工作简报
const WorkReport = () => import('@/components/workReport/WorkReport.vue')
//运营设置
const JuniorManage = () => import('@/components/runSet/JuniorManage.vue')
//在审件管理
const loan_management = () => import('@/components/client/ContractManage.vue') //在审件管理
const loan_manage = () => import('@/components/client/LoanList.vue') //在审件管理
const contract_manage = () => import('@/components/client/OnsiteCustomer.vue') //在审件管理
const addLoan = () => import('@/components/task/Loan.vue') //添加在审件
//任务
const today_customer = () => import('@/components/task/TodayCustomer.vue')
const pending_customer = () => import('@/components/client/pendClient.vue')
const job_record = () => import('@/components/task/JobRecord .vue')

const advStatic = () => import('@/components/advManage/AdvStatic.vue')
//业务设置
const sectorSetup = () => import('@/components/sectorSetup/SectorSetup.vue')
const staff_admin = () => import('@/components/sectorSetup/StaffAdmin.vue')
const task_set = () => import('@/components/sectorSetup/TaskSet.vue')
const mare_liberum_set = () => import('@/components/sectorSetup/MareLiberumSet.vue')
const pay_set = () => import('@/components/sectorSetup/IpSet.vue')
const ip_set = () => import('@/components/sectorSetup/IpSet.vue')
const organization_manage = () => import('@/components/runSet/OrganizationManage.vue')
const product_manage = () => import('@/components/runSet/ProductManage.vue')
const white_login_user = () => import('@/components/sectorSetup/WhiteLoginUser.vue')
const verify_code_record = () => import('@/components/sectorSetup/VerifyCodeRecord.vue')
//统计分析
const client_gross_analyse = () => import('@/components/statistics/ClientGrossAnalyse.vue')
const client_follow_analyse = () => import('@/components/statistics/ClientFollowAnalyse.vue')
const client_visit_analyse = () => import('@/components/statistics/ClientVisitAnalyse.vue')
const public_client_analyse = () => import('@/components/statistics/PublicClientAnalyse.vue')
const change_period_analyse = () => import('@/components/statistics/ChangePeriodAnalyse.vue')
const synthesize_analyse = () => import('@/components/statistics/SynthesizeAnalyse.vue')
const rank_list = () => import('@/components/statistics/RankingList.vue')
//数据统计
const data_report = () => import('@/components/statistics/DataReport.vue')
//媒体设置
const media_platform = () => import('@/components/runSet/MediaPlatform.vue')
const media_platform_withdraw = () => import('@/components/runSet/MediaPlatformWithdraw.vue')
const media_code = () => import('@/components/runSet/MediaCode.vue')

//渠道管理
const brand_manage = () => import('@/components/runSet/BrandManage.vue')
const junior_manage = () => import('@/components/runSet/JuniorManage.vue')
const junior_recharge = () => import('@/components/runSet/JuniorRecharge.vue')
const channel_name = () => import('@/components/runSet/ChannelName.vue')
const external_brand_manage = () => import('@/components/runSet/ExternalBrandManage.vue')
const upstreamAnalysis = () => import('@/components/runSet/upstreamAnalysis.vue')
const downstreamAnalysis = () => import('@/components/runSet/downstreamAnalysis.vue')

//运营统计
const media_statistics = () => import('@/components/runSet/MediaStatistics.vue')
const channel_statistics = () => import('@/components/runSet/ChannelStatistics.vue')
const client_statistics = () => import('@/components/runSet/ClientStatistics.vue')
const trend_analysis = () => import('@/components/runSet/TrendAnalysis')

//点击跳转页
const ClickJumpClient = () => import('@/components/client/ClickJumpClient.vue')
const ClickJumpSignClient = () => import('@/components/client/ClickJumpSignClient.vue')

//运营统计
const medium_count = () => import('@/components/finance/MediumCount.vue')
const medium_withdraw = () => import('@/components/finance/MediumWithdraw.vue')


//成本管理
const detail_list = () => import('@/components/runSet/DetailList.vue')
const advertising_cost = () => import('@/components/runSet/AdvertisingCost.vue')
const cost_set = () => import('@/components/runSet/CostSet.vue')
const cost_collect = () => import('@/components/runSet/CostCollect')
const advertising_manage = () => import('@/components/runSet/AdvertisingManage.vue')

//支出管理
const cost_report = () => import('@/components/finance/CostReport.vue')
const recharge_detail = () => import('@/components/finance/RechargeDetail.vue')
const consumption_report = () => import('@/components/finance/consumptionReport.vue')
//广告统计
const all_type_static = () => import('@/components/advManage/AdvAllTpyeStatic.vue')
const adv_static = () => import('@/components/advManage/AdvStatic.vue')
const account_static = () => import('@/components/advManage/AccountStatic.vue')
const account_manage = () => import('@/components/advManage/AccountManage.vue')
const adv_demand_manage = () => import('@/components/advManage/AdvDemandManage.vue')
const toutiao_adv_data = () => import('@/components/advManage/AdvList.vue')
const operater_log = () => import('@/components/advManage/OperaterLog.vue')
const operater_static = () => import('@/components/advManage/OperaterStatic.vue')
const adv_page_manage = () => import('@/components/advManage/AdvPageManage.vue')
const demand_data = () => import('@/components/advManage/DemandReport.vue')
const sucai_list = () => import('@/components/advManage/SucaiList.vue')
const wechat_data = () => import('@/components/advManage/WechatData.vue')
const cost_trends = () => import('@/components/advManage/CostTrends.vue')
const push_data_list = () => import('@/components/advManage/PushDataList.vue')
const interface_manage = () => import('@/components/advManage/InterfaceManage.vue')
const medium_mapping = () => import('@/components/advManage/MediumMapping.vue')
const digital_resource_management = () => import('@/components/advManage/DigitalResourceManagement.vue')
const adv_empty_cost = () => import('@/components/advManage/AdvEmptyCost.vue')
const adv_plan_manage = () => import('@/components/advManage/AdvPlanManage.vue')
const rong360_data = () => import('@/components/advManage/Rong360Data.vue')
//系统设置rong360_data
const login_log = () => import('@/components/admin/LoginLog.vue')
const data_monitoring = () => import('@/components/admin/DataMonitoring.vue')
const app_version = () => import('@/components/admin/AppVersion.vue')
const call_quality = () => import('@/components/admin/CallQuality.vue')


//财务管理

const finance_account_manage = () => import('@/components/FinanceManage/FinanceAccountManage.vue')
const finance_class_type = () => import('@/components/FinanceManage/FinanceClassType.vue')
const finance_flow = () => import('@/components/FinanceManage/FinanceFlow.vue')

// 双因素
const google2af = () => import('@/components/roleAuthority/google2af.vue')

const platform_cost_data = () => import('@/components/platformCostData/platformCostData.vue')
Vue.use(VueRouter)

const routes = [{
		path: '/'
	},
	{
		name: 'home',
		path: '/home',
		component: Home,
		redirect: '/home',
		children: [
			{
				path: '/myclient',
				component: MyClient,
				name: 'myclient',
				meta: {

					keepAlive: true,
					title: '我的客户',
					icon: 'md-home',
				}
			},
			{
				path: '/redistribution_client',
				component: RedistributionClient,
				name: 'redistribution_client',
				meta: {
					keepAlive: true,
					title: '再分配客户',
					icon: 'md-home',
				}
			},
			{
				path: '/introduce',
				component: Introduce,
				name: 'introduce',
				meta: {
					keepAlive: true,
					title: '我的所有客户',
					icon: 'md-home',
				}
			},
			{
				path: '/teamclient',
				component: TeamClient,
				name: 'teamclient',
				meta: {
					keepAlive: true,
					title: '团队客户',
					icon: 'md-home',
				}
			}, //在审件管理
			{
				path: '/task',
				component: task,
				name: 'task',
				meta: {
					keepAlive: true,
					title: '日志报表',
					icon: 'md-home',
				}
			}, //在审件管理
			{
				path: '/loan_management',
				component: loan_management,
				name: 'loan_management',
				meta: {
					keepAlive: true,
					title: '在审件管理',
					icon: 'md-home',
				}
			}, //合同管理
			{
				path: '/contract_manage',
				component: contract_manage,
				name: 'contract_manage',
				meta: {
					keepAlive: true,
					title: '合同管理',
					icon: 'md-home',
				}
			}, //公海
			{
				path: '/publicPool',
				component: publicPool,
				name: 'publicPool',
				meta: {
					keepAlive: true,
					title: '公共池',
					icon: 'md-home',
				}
			}, //重复客户
			{
				path: '/repeat_client',
				component: repeat_client,
				name: 'repeat_client',
				meta: {
					keepAlive: true,
					title: '重复客户',
					icon: 'md-home',
				}
			}, //离职人员数据分配
			{
				path: '/employee_client',
				component: employee_client,
				name: 'employee_client',
				meta: {
					keepAlive: true,
					title: '离职人员数据分配',
					icon: 'md-home',
				}
			}, //业绩排行榜
			{
				path: '/performance_ranking',
				component: performance_ranking,
				name: 'performance_ranking',
				meta: {
					keepAlive: true,
					title: '业绩排行榜',
					icon: 'md-home',
				}
			}, //
			{
				path: '/ImportantClient/:type',
				component: ImportantClient,
				name: 'ImportantClient',
				meta: {
					keepAlive: true,
					title: '我的重要客户',
					icon: 'md-home',
					access: true,
				}
			},
			{
				path: '/WorkReport',
				component: WorkReport,
				name: 'WorkReport',
				meta: {
					keepAlive: true,
					title: '工作简报',
					icon: 'md-home',
				}
			},
			{
				path: '/data_report',
				component: data_report,
				name: 'data_report',
				meta: {
					keepAlive: true,
					title: '数据统计',
					icon: 'md-home',
				}
			},
			{
				path: '/newEditClue/:id',
				component: newEditClue,
				name: 'newEditClue',
				meta: {
					access: true,
					keepAlive: true,
					title: '客户编辑',
					icon: 'md-home',
				}
			},
			{
				path: '/editClue/:id',
				component: editClue,
				name: 'editClue',
				meta: {
					access: true,
					keepAlive: true,
					title: '客户详情',
					icon: 'md-home',
				}
			},
			{
				path: '/addLoan',
				component: addLoan,
				name: 'addLoan',
				meta: {
					keepAlive: true,
					title: '添加在审件',
					icon: 'md-home',
				}
			},
			{
				path: '/HistoryCreateMoney',
				component: HistoryCreateMoney,
				name: 'HistoryCreateMoney',
				meta: {
					keepAlive: true,
					title: '部门创收',
					icon: 'md-home',
				}
			},
			{
				path: '/Memo',
				component: Memo,
				name: 'Memo',
				meta: {
					access: true,
					keepAlive: true,
					title: '备忘提醒',
					icon: 'md-home',
				}
			},
			{
				path: '/ClickJumpClient',
				component: ClickJumpClient,
				name: 'ClickJumpClient',
				meta: {
					keepAlive: true,
					title: '客户列表-新',
					icon: 'md-home',
				}
			},
			{
				path: '/ClickJumpSignClient',
				component: ClickJumpSignClient,
				name: 'ClickJumpSignClient',
				meta: {
					keepAlive: true,
					title: '签约列表-新',
					icon: 'md-home',
				}
			},
			{
				path: '/sectorSetup',
				component: sectorSetup,
				name: 'sectorSetup',
				meta: {
					keepAlive: true,
					title: '团队管理',
					icon: 'md-home',
				}
			},
			{
				name: 'myCenter',
				path: '/myCenter',
				component: MyCenter,
				meta: {
					access: true,
					keepAlive: true,
					title: '个人中心'
				}
			},
			{
				name: 'advStatic',
				path: '/advStatic',
				component: advStatic,
				meta: {
					keepAlive: true,
					title: '广告统计'
				}
			},
		]
	},
	//任务
	{
		path: '/homePage',
		name: 'homePage',
		component: Home,
		meta: {
			hideInBread: true,
			hideInMenu: true
		},
		children: [{
			path: '/homePage',
			name: 'homePage',
			meta: {
				keepAlive: true,
				icon: 'md-notifications',
				title: '工作台'
			},
			component: homePage
		}]
	},
	//任务
	{
		path: '/task',
		name: 'task',
		component: Home,
		meta: {
			hideInBread: true,
			hideInMenu: true
		},
		children: [{
			path: '/JuniorManage',
			name: 'JuniorManage',
			meta: {
				keepAlive: true,
				icon: 'md-notifications',
				title: '下级渠道管理'
			},
			component: JuniorManage
		}]
	},
	//下级渠道管理
	{
		path: '/run_set',
		name: 'run_set',
		component: Home,
		meta: {
			hideInBread: true,
			hideInMenu: true
		},
		children: [{
			path: '/JuniorManage',
			name: 'JuniorManage',
			meta: {
				keepAlive: true,
				icon: 'md-notifications',
				title: '下级渠道管理'
			},
			component: JuniorManage
		}]
	},
	//统计分析
	{
		path: '/statistics',
		name: 'statistics',
		component: Home,
		meta: {
			hideInBread: true,
			hideInMenu: true
		},
		children: [{
				path: '/client_gross_analyse',
				name: 'client_gross_analyse',
				meta: {
					keepAlive: true,
					icon: 'md-notifications',
					title: '客户总量分析'
				},
				component: client_gross_analyse
			},
			{
				path: '/client_follow_analyse',
				name: 'client_follow_analyse',
				meta: {
					keepAlive: true,
					icon: 'md-notifications',
					title: '客户跟进分析'
				},
				component: client_follow_analyse
			},
			{
				path: '/client_visit_analyse',
				name: 'client_visit_analyse',
				meta: {
					keepAlive: true,
					icon: 'md-notifications',
					title: '客户上门分析'
				},
				component: client_visit_analyse
			},
			{
				path: '/public_client_analyse',
				name: 'public_client_analyse',
				meta: {
					keepAlive: true,
					icon: 'md-notifications',
					title: '公海客户分析'
				},
				component: public_client_analyse
			},
			{
				path: '/change_period_analyse',
				name: 'change_period_analyse',
				meta: {
					keepAlive: true,
					icon: 'md-notifications',
					title: '转化周期分析'
				},
				component: change_period_analyse
			},
			{
				path: '/synthesize_analyse',
				name: 'synthesize_analyse',
				meta: {
					keepAlive: true,
					icon: 'md-notifications',
					title: 'M0分析'
				},
				component: synthesize_analyse
			},
			{
				path: '/synthesize_analyse',
				name: 'synthesize_analyse',
				meta: {
					keepAlive: true,
					icon: 'md-notifications',
					title: '综合分析'
				},
				component: synthesize_analyse
			},
			{
				path: '/rank_list',
				name: 'rank_list',
				meta: {
					keepAlive: true,
					icon: 'md-notifications',
					title: '排行榜'
				},
				component: rank_list
			},
		]
	},
	//任务
	{
		path: '/task',
		name: 'task',
		component: Home,
		meta: {
			hideInBread: true,
			hideInMenu: true
		},
		children: [{
				path: '/today_customer',
				name: 'today_customer',
				meta: {
					keepAlive: true,
					icon: 'md-notifications',
					title: '今日上门客户'
				},
				component: today_customer
			},
			{
				path: '/pending_customer',
				name: 'pending_customer',
				meta: {
					keepAlive: true,
					icon: 'md-notifications',
					title: 'WB客户'
				},
				component: pending_customer
			},
			{
				path: '/job_record',
				name: 'job_record',
				meta: {
					keepAlive: true,
					icon: 'md-notifications',
					title: '工作日志'
				},
				component: job_record
			},
		]
	},
	//媒体设置
	{
		path: '/media_set',
		name: 'media_set',
		component: Home,
		meta: {
			hideInBread: true,
			hideInMenu: true
		},
		children: [{
				path: '/media_platform',
				name: 'media_platform',
				meta: {
					keepAlive: true,
					icon: 'md-notifications',
					title: '媒体平台'
				},
				component: media_platform
			},
			{
				path: '/media_platform_withdraw',
				name: 'media_platform_withdraw',
				meta: {
					keepAlive: true,
					icon: 'md-notifications',
					title: '媒体提现'
				},
				component: media_platform_withdraw
			},
			{
				path: '/media_code',
				name: 'media_code',
				meta: {
					keepAlive: true,
					icon: 'md-notifications',
					title: '媒体代码'
				},
				component: media_code
			},
		]
	},
	//渠道管理
	{
		path: '/channel_manage',
		name: 'channel_manage',
		component: Home,
		meta: {
			hideInBread: true,
			hideInMenu: true
		},
		children: [{
				path: '/brand_manage',
				name: 'brand_manage',
				meta: {
					keepAlive: true,
					icon: 'md-notifications',
					title: '品牌负责人管理'
				},
				component: brand_manage
			},
			{
				path: '/junior_manage',
				name: 'junior_manage',
				meta: {
					keepAlive: true,
					icon: 'md-notifications',
					title: '下级渠道管理'
				},
				component: junior_manage
			},
			{
				path: '/junior_recharge',
				name: 'junior_recharge',
				meta: {
					keepAlive: true,
					icon: 'md-notifications',
					title: '渠道充值管理'
				},
				component: junior_recharge
			},
			{
				path: '/channel_name',
				name: 'channel_name',
				meta: {
					keepAlive: true,
					icon: 'md-notifications',
					title: '渠道名称管理'
				},
				component: channel_name
			},
			{
				path: '/external_brand_manage',
				name: 'external_brand_manage',
				meta: {
					keepAlive: true,
					icon: 'md-notifications',
					title: '外部品牌负责人管理'
				},
				component: external_brand_manage
			},
			{
				path: '/upstreamAnalysis',
				name: 'upstreamAnalysis',
				meta: {
					keepAlive: true,
					icon: 'md-notifications',
					title: '上游分析'
				},
				component: upstreamAnalysis
			},
			{
				path: '/downstreamAnalysis',
				name: 'downstreamAnalysis',
				meta: {
					keepAlive: true,
					icon: 'md-notifications',
					title: '下游分析'
				},
				component: downstreamAnalysis
			},
		]
	},
	//运营统计
	{
		path: '/run_statistics',
		name: 'run_statistics',
		component: Home,
		meta: {
			hideInBread: true,
			hideInMenu: true
		},
		children: [{
				path: '/media_statistics',
				name: 'media_statistics',
				meta: {
					keepAlive: true,
					icon: 'md-notifications',
					title: '媒体代码统计'
				},
				component: media_statistics
			},
			{
				path: '/channel_statistics',
				name: 'channel_statistics',
				meta: {
					keepAlive: true,
					icon: 'md-notifications',
					title: '渠道分配统计'
				},
				component: channel_statistics
			},
			{
				path: '/client_statistics',
				name: 'client_statistics',
				meta: {
					keepAlive: true,
					icon: 'md-notifications',
					title: '客户分配管理'
				},
				component: client_statistics
			},
			{
				path: '/trend_analysis',
				name: 'trend_analysis',
				meta: {
					keepAlive: true,
					icon: 'md-notifications',
					title: '趋势分析'
				},
				component: trend_analysis
			},
		]
	},
	//外围渠道
	{
		path: '/medium_manage',
		name: 'medium_manage',
		component: Home,
		meta: {
			hideInBread: true,
			hideInMenu: true
		},
		children: [{
				path: '/medium_count',
				name: 'medium_count',
				meta: {
					keepAlive: true,
					icon: 'md-notifications',
					title: '客户详情'
				},
				component: medium_count
			},
			{
				path: '/medium_withdraw',
				name: 'medium_withdraw',
				meta: {
					keepAlive: true,
					icon: 'md-notifications',
					title: '媒体提现申请'
				},
				component: medium_withdraw
			}
		]
	},
	//数据设置
	{
		path: '/sectorSetup',
		name: 'sectorSetup',
		component: Home,
		meta: {
			hideInBread: true,
			hideInMenu: true
		},
		children: [{
				path: '/staff_admin',
				name: 'staff_admin',
				meta: {
					keepAlive: true,
					icon: 'md-notifications',
					title: '数据设置'
				},
				component: staff_admin
			},
			{
				path: '/pay_set',
				name: 'pay_set',
				meta: {
					keepAlive: true,
					icon: 'md-notifications',
					title: '薪资设置'
				},
				component: pay_set
			},
			{
				path: '/task_set',
				name: 'task_set',
				meta: {
					keepAlive: true,
					icon: 'md-notifications',
					title: '任务设置'
				},
				component: task_set
			},
			{
				path: '/mare_liberum_set',
				name: 'mare_liberum_set',
				meta: {
					keepAlive: true,
					icon: 'md-notifications',
					title: '回收设置'
				},
				component: mare_liberum_set
			},
			{
				path: '/ip_set',
				name: 'ip_set',
				meta: {
					keepAlive: true,
					icon: 'md-notifications',
					title: 'IP设置'
				},
				component: ip_set
			},
			{
				path: '/organization_manage',
				name: 'organization_manage',
				meta: {
					keepAlive: true,
					icon: 'md-notifications',
					title: '机构管理'
				},
				component: organization_manage
			},
			{
				path: '/product_manage',
				name: 'product_manage',
				meta: {
					keepAlive: true,
					icon: 'md-notifications',
					title: '产品管理'
				},
				component: product_manage
			},
			{
				path: '/white_login_user',
				name: 'white_login_user',
				meta: {
					keepAlive: true,
					icon: 'md-notifications',
					title: '登录白名单管理'
				},
				component: white_login_user
			},
			{
				path: '/verify_code_record',
				name: 'verify_code_record',
				meta: {
					keepAlive: true,
					icon: 'md-notifications',
					title: '查看验证码记录'
				},
				component: verify_code_record
			},
		]
	},
	//权限设置
	{
		path: '/Setup',
		name: 'Setup',
		component: Home,
		meta: {
			hideInBread: true,
			hideInMenu: true
		},
		children: [{
				path: '/roleAuthority',
				name: 'roleAuthority',
				meta: {
					access: true,
					keepAlive: true,
					icon: 'md-notifications',
					title: '角色权限'
				},
				component: RoleAuthority
			},
			{
				path: '/organizationMember',
				name: 'organizationMember',
				meta: {
					access: true,
					keepAlive: true,
					icon: 'md-notifications',
					title: '组织成员'
				},
				component: OrganizationMember
			},
		]
	},
	//成本管理
	{
		path: '/cost_admin',
		name: 'cost_admin',
		component: Home,
		meta: {
			hideInBread: true,
			hideInMenu: true
		},
		children: [{
				path: '/detail_list',
				name: 'detail_list',
				meta: {
					keepAlive: true,
					icon: 'md-notifications',
					title: '成本明细表'
				},
				component: detail_list
			},
			{
				path: '/advertising_cost',
				name: 'advertising_cost',
				meta: {
					keepAlive: true,
					icon: 'md-notifications',
					title: '未录入成本汇总'
				},
				component: advertising_cost
			},
			{
				path: '/cost_set',
				name: 'cost_set',
				meta: {
					keepAlive: true,
					icon: 'md-notifications',
					title: '成本方式设置'
				},
				component: cost_set
			},
			{
				path: '/cost_collect',
				name: 'cost_collect',
				meta: {
					keepAlive: true,
					icon: 'md-notifications',
					title: '成本汇总表'
				},
				component: cost_collect
			},
			{
				path: '/advertising_manage',
				name: 'advertising_manage',
				meta: {
					keepAlive: true,
					icon: 'md-notifications',
					title: '对外成本'
				},
				component: advertising_manage
			},
		]
	},
	//支出管理
	{
		path: '/expenditure_manage',
		name: 'expenditure_manage',
		component: Home,
		meta: {
			hideInBread: true,
			hideInMenu: true
		},
		children: [{
				path: '/cost_report',
				name: 'cost_report',
				meta: {
					keepAlive: true,
					icon: 'md-notifications',
					title: '成本报表'
				},
				component: cost_report
			},
			{
				path: '/recharge_detail',
				name: 'recharge_detail',
				meta: {
					keepAlive: true,
					icon: 'md-notifications',
					title: '充值明细'
				},
				component: recharge_detail
			},
			{
				path: '/consumption_report',
				name: 'consumption_report',
				meta: {
					keepAlive: true,
					icon: 'md-notifications',
					title: '融3消耗'
				},
				component: consumption_report
			},
		]
	},
	
	//广告统计
	{
		path: '/advStatic',
		name: 'advStatic',
		component: Home,
		meta: {
			hideInBread: true,
			hideInMenu: true
		},
		children: [{
			path: '/all_type_static',
			name: 'all_type_static',
			meta: {
				keepAlive: true,
				icon: 'md-notifications',
				title: '所有类型分析'
			},
			component: all_type_static
		}, {
			path: '/account_static',
			name: 'account_static',
			meta: {
				keepAlive: true,
				icon: 'md-notifications',
				title: '账户统计'
			},
			component: account_static
		}, {
			path: '/account_manage',
			name: 'account_manage',
			meta: {
				keepAlive: true,
				icon: 'md-notifications',
				title: '账户管理'
			},
			component: account_manage
		}, {
			path: '/adv_demand_manage',
			name: 'adv_demand_manage',
			meta: {
				keepAlive: true,
				icon: 'md-notifications',
				title: '需求管理'
			},
			component: adv_demand_manage
		}, {
			path: '/toutiao_adv_data',
			name: 'toutiao_adv_data',
			meta: {
				keepAlive: true,
				icon: 'md-notifications',
				title: '头条广告管理'
			},
			component: toutiao_adv_data
		}, {
			path: '/operater_static',
			name: 'operater_static',
			meta: {
				keepAlive: true,
				icon: 'md-notifications',
				title: '运营人员分析'
			},
			component: operater_static
		}, {
			path: '/operater_log',
			name: 'operater_log',
			meta: {
				keepAlive: true,
				icon: 'md-notifications',
				title: '运营日志'
			},
			component: operater_log
		}, {
			path: '/adv_page_manage',
			name: 'adv_page_manage',
			meta: {
				keepAlive: true,
				icon: 'md-notifications',
				title: '落地页管理'
			},
			component: adv_page_manage
		}, {
			path: '/demand_data',
			name: 'demand_data',
			meta: {
				keepAlive: true,
				icon: 'md-notifications',
				title: '需求统计报表'
			},
			component: demand_data
		}, {
			path: '/sucai_list',
			name: 'sucai_list',
			meta: {
				keepAlive: true,
				icon: 'md-notifications',
				title: '素材管理'
			},
			component: sucai_list
		}, {
			path: '/wechat_data',
			name: 'wechat_data',
			meta: {
				keepAlive: true,
				icon: 'md-notifications',
				title: '朋友圈数据'
			},
			component: wechat_data
		}, {
			path: '/cost_trends',
			name: 'cost_trends',
			meta: {
				keepAlive: true,
				icon: 'md-notifications',
				title: '成本趋势'
			},
			component: cost_trends
		}, {
			path: '/push_data_list',
			name: 'push_data_list',
			meta: {
				keepAlive: true,
				icon: 'md-notifications',
				title: '推送趋势'
			},
			component: push_data_list
		}, {
			path: '/interface_manage',
			name: 'interface_manage',
			meta: {
				keepAlive: true,
				icon: 'md-notifications',
				title: '接口列表'
			},
			component: interface_manage
		}, {
			path: '/medium_mapping',
			name: 'medium_mapping',
			meta: {
				keepAlive: true,
				icon: 'md-notifications',
				title: '媒体接口表'
			},
			component: medium_mapping
		}, {
			path: '/digital_resource_management',
			name: 'digital_resource_management',
			meta: {
				keepAlive: true,
				icon: 'md-notifications',
				title: '数字资源管理'
			},
			component: digital_resource_management
		}, {
			path: '/AdvEmptyCost.vue',
			name: 'adv_empty_cost',
			meta: {
				keepAlive: true,
				icon: 'md-notifications',
				title: '投放标准设置'
			},
			component: adv_empty_cost
		}, {
			path: '/adv_plan_manage',
			name: 'adv_plan_manage',
			meta: {
				keepAlive: true,
				icon: 'md-notifications',
				title: '投放计划管理'
			},
			component: adv_plan_manage
		}, {
			path: '/rong360_data',
			name: 'rong360_data',
			meta: {
				keepAlive: true,
				icon: 'md-notifications',
				title: 'rong统计'
			},
			component: rong360_data
		}, {
			path: '/platform_cost_data',
			name: 'platform_cost_data',
			meta: {
				keepAlive: true,
				icon: 'md-notifications',
				title: '平台消耗数据'
			},
			component: platform_cost_data
		}
		]
	},
	//通知中心
	{
		path: '/info',
		name: 'info',
		component: Home,
		meta: {
			hideInBread: true,
			hideInMenu: true
		},
		children: [{
			path: '/informcenter',
			name: 'informcenter',
			meta: {
				access: true,
				keepAlive: true,
				icon: 'md-notifications',
				title: '通知中心'
			},
			component: informcenter
		}]
	},
	//系统设置
	{
		path: '/expenditure_manage',
		name: 'expenditure_manage',
		component: Home,
		meta: {
			hideInBread: true,
			hideInMenu: true
		},
		children: [{
				path: '/login_log',
				name: 'login_log',
				meta: {
					keepAlive: true,
					icon: 'md-notifications',
					title: '登录日志'
				},
				component: login_log
			},{
				path: '/data_monitoring',
				name: 'data_monitoring',
				meta: {
					keepAlive: true,
					icon: 'md-notifications',
					title: '数据监控'
				},
				component: data_monitoring
			},{
				path: '/app_version',
				name: 'app_version',
				meta: {
					keepAlive: true,
					icon: 'md-notifications',
					title: 'App版本配置'
				},
				component: app_version
			},{
				path: '/call_quality',
				name: 'call_quality',
				meta: {
					keepAlive: true,
					icon: 'md-call',
					title: '通话质检'
				},
				component: call_quality
			},
		]
	},
	//财务管理
	{
		path: '/finance',
		name: 'finance',
		component: Home,
		meta: {
			hideInBread: true,
			hideInMenu: true
		},
		children: [{
				path: '/finance_account_manage',
				name: 'finance_account_manage',
				meta: {
					keepAlive: true,
					icon: 'md-notifications',
					title: '账户管理'
				},
				component: finance_account_manage
			},{
				path: '/finance_class_type',
				name: 'finance_class_type',
				meta: {
					keepAlive: true,
					icon: 'md-notifications',
					title: '收支类型'
				},
				component: finance_class_type
			},{
				path: '/finance_flow',
				name: 'finance_flow',
				meta: {
					keepAlive: true,
					icon: 'md-notifications',
					title: '流水记录'
				},
				component: finance_flow
			},
		],
	},
	// 商户客户线索
	{
		name: 'shop_client',
		path: '/shop_client',
		component: ShopClient,
		meta: {
			keepAlive: true,
			title: '客户线索'
		}
	},
	// 帮助中心
	{
		name: 'helpCenter',
		path: '/helpCenter',
		component: HelpCenter,
		meta: {
			keepAlive: true,
			title: '帮助中心'
		}
	},
	// 人才库
	{
		name: 'talentpool',
		path: '/talentpool',
		component: TalentPool,
		meta: {
			keepAlive: true,
			title: '人才库'
		}
	},
	// 新增人才
	{
		name: 'newtalents',
		path: '/newtalents',
		component: NewTalents,
		meta: {
			keepAlive: true,
			title: '新增人才'
		}
	},
	// 后台设置
	{
		name: 'adminSet',
		path: '/adminSet',
		component: adminSet,
		meta: {
			keepAlive: true,
			title: '后台设置'
		}
	},
	// 信息查询列表
	{
		name: 'information',
		path: '/information',
		component: information,
		meta: {
			keepAlive: true,
			title: '信息查询列表'
		}
	},
	{
		name: 'login',
		path: '/login',
		meta: {
			keepAlive: true,
			title: '登录中心',
			hideInMenu: true,
			access: true,
		},
		component: Login
	},
	{
		name: 'chooseShop',
		path: '/chooseShop',
		meta: {
			keepAlive: true,
			title: '选择子公司',
			hideInMenu: true
		},
		component: ChooseShop
	},
	{
		path: '/401',
		name: 'error_401',
		meta: {
			hideInMenu: true,
			access: true,
		},
		component: () => import('@/views/error-page/401.vue')
	},
	{
		path: '/500',
		name: 'error_500',
		meta: {
			hideInMenu: true
		},
		component: () => import('@/views/error-page/500.vue')
	},
	{
		path: '*',
		name: 'error_404',
		meta: {
			hideInMenu: true,

		},
		component: () => import('@/views/error-page/404.vue')
	},
	{
		path: '/google2af',
		name: 'google2af',
		meta: {
			access: true,
			icon: 'md-notifications',
			title: '双因素认证'
		},
		component: google2af
	},
]

const router = new VueRouter({
	routes
})
router.beforeEach((to, from, next) => {
	iView.LoadingBar.start()
	const token = getToken()
	if (to.meta.content) {
		let head = document.getElementsByTagName('head');
		let meta = document.createElement('meta');
		meta.content = to.meta.content;
		head[0].appendChild(meta)
	}

	/* 路由发生变化修改页面title */
	if (to.meta.title) {
		document.title = to.meta.title;
	}
	if (!token && to.name !== 'login') {
		// 未登录且要跳转的页面不是登录页
		console.log('进来这里')
		next({
			name: 'login' // 跳转到登录页
		})
	} else {
		if (store.state.user.userInfo.menuList) {
			//如果存在则进行权限规则校验
			console.log(store.state.user.userInfo)
			console.log(token)
			var arr = Object.values(store.state.user.userInfo.menuList) //将菜单转为数组
			if (canTurnTo(to.name, arr, routes) || to.meta.access == true) {
				next()
			} else {
				next({
					replace: true,
					name: 'error_401'
				})
			}
		} else {
			//没有则进行登录
			next()
		}


	}
	/*如果本地 存在 token 则 不允许为空，直接跳到我的客户页面*/
	if (to.fullPath == "/") {
		if (token) {
			if (store.state.user.userInfo.role_type == 1) {
				next({
					path: 'client_statistics'
				});
			} else if (store.state.user.userInfo.role_type == 2) {
				next({
					path: 'myclient'
				});
			} else {
				next({
					path: 'myclient'
				});
			}

		} else {
			console.log(store.state.user.userInfo.role_type == 1)
			next();
		}
	}


})


router.afterEach(to => {
	iView.LoadingBar.finish()
	window.scrollTo(0, 0)
})


export default router
